/**
 * UI adapter: UC-15 EvaluateThreat
 */
import { architectureFeatures } from '../../../infrastructure/config/features';
import { evaluateThreatUseCase } from '../../../infrastructure/di/container';
import { EvaluateThreatUseCase } from '../../../application/use-cases/EvaluateThreatUseCase';
import type {
  EvaluateThreatInput,
  EvaluateThreatOutput,
} from '../../../application/use-cases/EvaluateThreatUseCase';

export type { EvaluateThreatInput, EvaluateThreatOutput };

export function resolveEvaluateThreat(input: EvaluateThreatInput): EvaluateThreatOutput {
  if (architectureFeatures.useThreatEvaluationUseCase) {
    return evaluateThreatUseCase.execute(input);
  }
  return new EvaluateThreatUseCase().execute(input);
}